import Modal from './modal';
import Dialog from '../Dialog';
import './index.css';

Modal.confirm = Dialog.confirm;

export default Modal;